// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"DZ-z","subtitle":"EZ-z","wrapper":"FZ-z","leftArrow":"GZ-z","rightArrow":"HZ-z"};